export const VNREVENUECENTERS_SET_MENUS = 'VNREVENUECENTERS_SET_MENUS'
export const VNREVENUECENTERS_SET_MENUS_BY_STANDS = 'VNREVENUECENTERS_SET_MENUS_BY_STANDS'
export const VNREVENUECENTERS_SET_STANDS = 'VNREVENUECENTERS_SET_STANDS'
export const VNREVENUECENTERS_SET_STANDS_BY_ID = 'VNREVENUECENTERS_SET_STANDS_BY_ID'
export const VNREVENUECENTERS_SET_SALES_EVENTS = 'VNREVENUECENTERS_SET_SALES_EVENTS'
export const VNREVENUECENTERS_SET_CROSS_VENUE_STAND = 'VNREVENUECENTERS_SET_CROSS_VENUE_STAND'
